import { css } from '@emotion/react';
import React from 'react';
import theme from '../../theme';
import mypage1Img from 'url:./mypage1.jpg';
import mypage2Img from 'url:./mypage2.jpg';
import step2Img from 'url:./step2.jpg';
import step3Img from 'url:./step3.jpg';
import step4Img from 'url:./step4.jpg';
import step5Img from 'url:./step5.jpg';
import step6Img from 'url:./step6.jpg';
import step7Img from 'url:./step7.jpg';

export default function Manual () {
  const header = title => (
    <h2 css={css`background-color: ${theme.colors.primary}; color: white; font-size: 20px; padding: 0.5rem 1rem; text-align: center; margin-bottom: 3rem`}>
      <Safe>
        {title}
      </Safe>
    </h2>
  );

  return (
    <div>
      <h1 css={css`text-align: center; margin-bottom: 3rem`}>操作マニュアル</h1>
      {header('マイページについて')}
      <Safe>
        <Step title="学科一覧" screen={mypage1Img}>
          マイページにログインすると、学科の一覧と、その学科の受講ステータスが表示されます。受講ステータスは受講が完了すると受講済みになります。<br />
          <br />
          2段階目の学科は1段階が完了したあと、教習所側の確認が完了すると、内容が表示されます。
        </Step>
        <Step title="受講内容の確認" screen={mypage2Img}>
          受講した直後の学科は、受講ステータスが「教習所確認中」になります。<br />
          <br />
          送信いただいた受講内容の確認の取れ次第、ステータスが「受講完了」に変わります。<br />
          <br />
          「撮影写真」を押すと、教習中に撮影した顔写真が確認出来ます。
        </Step>
      </Safe>
      {header('受講の流れ')}
      <Safe>
        <Step no="1" title="受講の開始" screen={mypage1Img}>
          マイページの学科一覧から希望する学科の、「受講する」ボタンを押して受講を開始してください。
        </Step>
        <Step no="2" title="2段階認証" screen={step2Img}>
          登録したメールアドレスに届いた確認コードを入力して、「認証コード」を送信を押してください。
        </Step>
        <Step no="3" title="受講開始" screen={step3Img}>
          注意書きをよく読んで、「同意する」をチェックして、「同意してカメラの設定へ」を押してください。<br></br>
          カメラの許可を求めるダイアログが表示されるので、カメラの利用を許可してください。
        </Step>
        <Step no="4" title="カメラプレビュー" screen={step4Img}>
          学科受講中に3回顔写真の撮影を行います。<br />
          画面に映ったカメラの画像を確認して、顔が撮影できる位置を確認してください。<br />
          問題無ければ、「受講を開始する」を押してください。
        </Step>
        <Step no="5" title="確認問題" screen={step5Img}>
          動画視聴中に3回、動画の内容に関する問題が表示されますので、2分以内に回答して、先に進んでください。<br />
          回答しないで時間切れになってしまうと、再受講が必要になります。
        </Step>
        <Step no="6" title="効果測定" screen={step6Img}>
          動画視聴後に学科の理解をチェックする効果測定テストを行います。<br />
          回答できましたら、「テストを送信」を押してください。
        </Step>
        <Step no="7" title="受講完了" screen={step7Img}>
          以上で受講は完了です!
        </Step>
      </Safe>
    </div>
  )
};

const Step = ({no, children, title, screen}) => {
  return (
    <div css={css`
      display: flex;
      margin-bottom: 6rem;
      @media screen and (max-width: 959px) {
        flex-direction: column;
      }
    `}>
      <div css={css`flex: 1`}>
        <div css={css`display: flex; align-items: center; margin-bottom: 1.5rem`}>
          {no && <span css={css`background-color: ${theme.colors.accent}; color: white; padding: 0.5rem; line-height: 1; margin-right: 1rem`}>STEP{no}</span>}
          <h3>{title}</h3>
        </div>
        {children}
      </div>
      <div css={css`
        margin-left: 2rem;
        @media screen and (max-width: 959px) {
          margin-left: 0;
          margin-top: 2rem;
        }
      `}>
        <img src={screen} width="420" height="315" css={css`border: 1px solid black; display: block; margin: auto; max-width: 100%; height: auto`}/>
      </div>
    </div>
  )
};

const Safe = ({children}) => <div css={css`
  max-width: 960px; margin: auto; padding: 0 2rem;
  @media screen and (max-width: 479px) {
    padding: 0 1rem;
  }
`}>{children}</div>
